<template>
  <div class="benefits">
    <div>
      <div class="icon-wrapper">
        <i class="coin-in-hand"></i>
      </div>
      <span>bis zu 80% bezuschusst</span>
    </div>

    <div>
      <div class="icon-wrapper">
        <i class="certificate"></i>
      </div>
      <span> von gesetzlichen Krankenkassen geprüft & zertifiziert </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.benefits {
  color: var(--text-color-invert);
  display: flex;
  gap: 8px;
  margin: 0 16px;
  padding: 16px 0;

  > div {
    align-items: center;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;

    i {
      margin: 8px;

      &.coin-in-hand,
      &.certificate {
        background-color: var(--background-color-base);
        mix-blend-mode: darken;
      }
    }

    span {
      align-content: center;
      flex: 1;
      font-weight: bold;
      margin: 0;
      padding: 4px;
      width: 100%;
    }
  }
}
</style>
